import { Flex } from 'antd'
import Icon, { IconName } from '@/components/icon'
import Image from '@/components/image'
import Styles from './style.module.scss'

interface DataItemProps {
  icon: IconName
  title: string
  description: string
}

const TITLE = 'How It Works'
const data: DataItemProps[] = [
  {
    icon: 'blueBattery',
    title: 'Assessment',
    description: 'Identify critical loads, runtime needs, and charging windows',
  },
  {
    icon: 'blueDashboard',
    title: 'Operation',
    description: 'Continuous EMS monitoring, early- warning alerts, and performance reporting',
  },
  {
    icon: 'blueReceived',
    title: 'Deployment',
    description: 'Rapid delivery and plug-in connection (off-grid/grid-support/PV-coupled)',
  },
]

export default function Work() {
  return (
    <div className={Styles.work}>
      <h2>{TITLE}</h2>
      <Flex justify='center' wrap className={Styles.content}>
        {data.map(item => (
          <Flex key={item.title} className={Styles.item}>
            <Icon name={item.icon} className={Styles.icon} />
            <Flex vertical className={Styles.textWrapper}>
              <div className={Styles.title}>{item.title}</div>
              <div className={Styles.description}>{item.description}</div>
            </Flex>
          </Flex>
        ))}
      </Flex>
    </div>
  )
}
